import * as formik from "formik";
import toast, { Toaster } from 'react-hot-toast';
import * as yup from 'yup';
import { useAppDispatch } from "src/hooks/redux/hooks";
import { Button, Form } from 'react-bootstrap';
import "./SignIn.css"
import { ISignInCredentials, ISignUpCredentials } from "src/store/auth/authApi";
import { adminSignUp, adminSignInSlice, setRefreshTokens } from "src/store/auth/authSlice";
import { useNavigate } from "react-router-dom";
// import { useEffect } from "react";
import Cookies from 'js-cookie';
const SignInPage = () => {
    const { Formik, Field, ErrorMessage } = formik;
    const dispatch = useAppDispatch();
    const navigate = useNavigate()

    const validationSchema = yup.object().shape({
        // name: yup.string().required("Please enter your name!"),
        email: yup.string().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, "Invalid email address").required("Email is a required field."),
        password: yup.string().required("Password is a required field.").min(8, 'Password must be at least 8 characters'),
    });
    const initialValues = {
        name: '',
        email: '',
        password: '',
    };

    const handleFormSubmit = async (formInput: any) => {
        // console.log(formInput)
        const formData = new FormData();
        formData.append('email', formInput.email);
        formData.append('password', formInput.password);


        // formData.forEach((value, key) => {
        //     console.log(key, value);
        // });

        const signInCredentials: ISignInCredentials = {
            email: formInput.email,
            password: formInput.password,
        };

        await dispatch(adminSignInSlice(signInCredentials)).then((result) => {

            const resValue = result?.payload;
            // console.log(resValue)
            if (resValue?.status_code === 200) {

                const token = resValue?.data?.token as string;
                const refreshToken = resValue?.data?.refreshToken as string

                // dispatch(setRefreshTokens(newTokens));
                Cookies.set('token', token, { expires: 7, secure: true });
                Cookies.set('refreshToken', refreshToken, { secure: true });

                toast.success("Logged in successfully.",
                    {
                        position: "top-right",
                        duration: 2000
                    }
                )
                setTimeout(() => {
                    navigate("/home")
                }, 1000)
            }
            else {
                // console.log(resValue)
                toast.error(resValue?.msg, {
                    position: "top-right",
                    duration: 2000
                })
            }

        }).catch((err: any) => {
            console.log(err)
            toast.error(err.message,
                {
                    position: "top-right",
                    duration: 2000
                }
            )
        });

    }

    return (
        <>
            <div className="bg-gray-200">
                <Toaster />

                <main className="main-content  mt-0">
                    <div className="page-header align-items-start min-vh-100">
                        <span className="mask bg-gradient-dark opacity-6"></span>
                        <div className="container my-auto">
                            <div className="row">
                                <div className="col-lg-4 col-md-8 col-12 mx-auto">
                                    <div className="card z-index-0 fadeIn3 fadeInBottom">
                                        <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                            <div className="bg-gradient-primary shadow-primary border-radius-lg py-3 pe-1">
                                                <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">Sign in</h4>
                                                <div className="row mt-3">
                                                    <div className="col-2 text-center ms-auto">
                                                        <a className="btn btn-link px-3" href="javascript:;">
                                                            <i className="fa fa-facebook text-white text-lg"></i>
                                                        </a>
                                                    </div>
                                                    <div className="col-2 text-center px-1">
                                                        <a className="btn btn-link px-3" href="javascript:;">
                                                            <i className="fa fa-github text-white text-lg"></i>
                                                        </a>
                                                    </div>
                                                    <div className="col-2 text-center me-auto">
                                                        <a className="btn btn-link px-3" href="javascript:;">
                                                            <i className="fa fa-google text-white text-lg"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body m-4 m-md-1">

                                            <Formik
                                                validationSchema={validationSchema}
                                                onSubmit={(values) => {

                                                    handleFormSubmit(values)
                                                }}
                                                // onSubmit={handleFormSubmit}
                                                initialValues={initialValues}
                                                validateOnBlur={false}
                                                validateOnChange={false}
                                            >
                                                {({ handleSubmit, handleChange, values, touched, errors }) => (

                                                    <Form noValidate onSubmit={handleSubmit} className='auth-form'>

                                                        <Form.Group className="text-start mb-3" >
                                                            <Form.Label className="form_label" htmlFor='email'>Email address</Form.Label>
                                                            <Form.Control className="input_class" id="email" type='email' name="email" value={values.email}
                                                                onChange={handleChange} isValid={touched.email && !errors.email} isInvalid={!!errors.email} />
                                                            <Form.Control.Feedback type="invalid" className="text-start">
                                                                {errors.email}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group className="text-start mb-3" >
                                                            <Form.Label className="form_label" htmlFor='password'>Password</Form.Label>
                                                            <Form.Control className="input_class" id="password" type='password' name="password" value={values.password}
                                                                onChange={handleChange} isValid={touched.password && !errors.password} isInvalid={!!errors.password} />
                                                            <Form.Control.Feedback type="invalid" className="text-start">
                                                                {errors.password}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Button as="button" variant='btn btn-lg bg-gradient-primary btn-lg w-100 mt-4 mb-0' type='submit'>
                                                            Sign In
                                                        </Button>

                                                    </Form>

                                                )}
                                            </Formik>

                                            {/* <p className="mt-4 text-sm text-center">
                                                Don't have an account?
                                                <a href="../sign-up" className="text-primary text-gradient font-weight-bold">Sign up</a>
                                            </p> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
            </div>
            {/* <!--   Core JS Files   --> */}
            <script src="../assets/js/core/popper.min.js"></script>
            <script src="../assets/js/core/bootstrap.min.js"></script>
            <script src="../assets/js/plugins/perfect-scrollbar.min.js"></script>
            <script src="../assets/js/plugins/smooth-scrollbar.min.js"></script>
        </>
    )

}


export default SignInPage;